import {
  AlignLeftOutlined,
  BankOutlined,
  BarcodeOutlined,
  DollarOutlined,
  DownloadOutlined,
  RightOutlined,
  StarOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Button,
  Card,
  List,
  Modal,
  Tabs,
  TabsProps,
  Typography,
} from 'antd';
import Meta from 'antd/es/card/Meta';
import { useContext, useState } from 'react';
import { DashboardContext } from '../..';
import getNudges from '../../../../Utils/nudgeUtils';
import { getAccountProfile } from '../../../../Utils/storageUtils';
import {
  fipIdNameMapping,
  formatToINR,
  getPDFURL,
} from '../../../../Utils/utils';
import AllTransactions from '../../AllTransactions';
import Nudges from '../../Nudges';
import AccountsSummary from '../AccountSummary';
import styles from './index.module.css';

const BankSummary = () => {
  const [accounts, setActiveAccounts] = useState<any[]>(
    getAccountProfile()?.map((account: any) => {
      return {
        accNo: account.maskedNumber.slice(-6),
        balance: account.amount,
        lastUpdatedTime: '',
        ifscCode: account.ifscCode,
        fipId: fipIdNameMapping[account.bankName],
        fipName: account.bankName,
        accType: account.accType,
        holderName: account.holderName,
        holderAddress: account.holderAddress,
        holderMobile: account.holderMobile,
        holderEmail: account.holderEmail,
      };
    })
  );
  const [isAccountDetailsOpen, setIsAccountDetailsOpen] = useState(false);

  const [activeKey, setActiveKey] = useState('1');
  const [selectedAcconts, setSelectedAccounts] = useState<any>(accounts[0]);
  const {
    pausedAccounts,
    setPausedAccounts,
    revokedAccounts,
    setRevokedAccounts,
  }: any = useContext(DashboardContext);
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Account Summary',
      children: <AccountsSummary selectedAccounts={selectedAcconts.accNo} />,
    },
    {
      key: '2',
      label: 'All Transactions',
      children: <AllTransactions selectedAccounts={selectedAcconts.accNo} />,
    },
  ];

  return (
    <>
      <Modal
        open={isAccountDetailsOpen}
        onCancel={() => setIsAccountDetailsOpen(false)}
        footer={false}
        title={
          <>
            <Typography.Title level={3}>Account Details</Typography.Title>
            {/* <List.Item> */}
            <Typography.Title level={5}>
              {selectedAcconts.holderName}
            </Typography.Title>
            <div style={{ display: 'flex', gap: 10 }}>
              {/* <Typography.Text style={{fontWeight : 400}}>{selectedAcconts.holderPhone}</Typography.Text> */}
              {/* <Typography.Text style={{fontWeight : 400}}>{selectedAcconts.holderEmail}</Typography.Text> */}
              <Typography.Text style={{ fontWeight: 400 }}>
                {selectedAcconts.holderAddress}
              </Typography.Text>
            </div>
          </>
        }
      >
        <>
          <List
            itemLayout='horizontal'
            dataSource={[
              {
                title: 'Account Number',
                value: selectedAcconts.accNo,
                icon: (
                  <BankOutlined
                    style={{
                      backgroundColor: 'blue',
                      color: 'white',
                    }}
                  />
                ),
              },
              {
                title: 'Balance',
                value: formatToINR(selectedAcconts.balance),
                icon: <DollarOutlined />,
              },
              {
                title: 'IFSC Code',
                value: selectedAcconts.ifscCode,
                icon: <BarcodeOutlined />,
              },
              {
                title: 'Account Type',
                value: selectedAcconts.accType,
                icon: <StarOutlined />,
              },
              // {
              //   title : "Your Address",
              //   value : selectedAcconts.holderAddress,
              //   icon : <HomeOutlined />
              // }
            ]}
            renderItem={(item, index) => (
              <List.Item>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor: '#0460ff',
                        marginTop: 8,
                        fontSize: 20,
                      }}
                      icon={item.icon}
                    />
                  }
                  title={
                    <Typography.Text
                      style={{
                        color: 'rgb(152 152 152)',
                        fontWeight: 400,
                        fontSize: 14,
                      }}
                    >
                      {item.title}
                    </Typography.Text>
                  }
                  description={
                    <Typography.Text
                      style={{
                        fontWeight: 500,
                        color: 'black',
                        fontSize: 16,
                      }}
                    >
                      {item.value}
                    </Typography.Text>
                  }
                />
              </List.Item>
            )}
          />

          {!revokedAccounts.includes(selectedAcconts.accNo.slice(-4)) ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 15,
              }}
            >
              {
                <Button
                  className={styles.consentStatusStatus}
                  onClick={() => {
                    if (
                      !pausedAccounts.includes(selectedAcconts.accNo.slice(-4))
                    ) {
                      setPausedAccounts(
                        pausedAccounts.concat(selectedAcconts.accNo.slice(-4))
                      );
                    } else {
                      setPausedAccounts(
                        pausedAccounts.filter(
                          (acc: string) =>
                            acc !== selectedAcconts.accNo.slice(-4)
                        )
                      );
                    }
                    setIsAccountDetailsOpen(false);
                  }}
                >
                  {' '}
                  {!pausedAccounts.includes(selectedAcconts.accNo.slice(-4))
                    ? 'Pause consent'
                    : 'Resume consent'}
                </Button>
              }{' '}
              <Button
                className={styles.consentStatusStatus}
                onClick={() => {
                  if (
                    !revokedAccounts.includes(selectedAcconts.accNo.slice(-4))
                  ) {
                    setRevokedAccounts(
                      revokedAccounts.concat(selectedAcconts.accNo.slice(-4))
                    );
                  } else {
                    setRevokedAccounts(
                      revokedAccounts.filter(
                        (acc: string) => acc !== selectedAcconts.accNo.slice(-4)
                      )
                    );
                  }
                  setIsAccountDetailsOpen(false);
                }}
              >
                Revoke consent
              </Button>
            </div>
          ) : (
            <></>
          )}
        </>
      </Modal>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', width: '100%', overflowX: 'auto' }}>
            {accounts.map((acc) => {
              return (
                <div
                  className={`${styles.accounts} yourBanksAccounts ${
                    acc.accNo === selectedAcconts.accNo
                      ? styles.selectedAcconts
                      : ''
                  }`}
                  onClick={() => {
                    if (acc !== selectedAcconts.accNo) setSelectedAccounts(acc);
                  }}
                >
                  <div className={styles.bankLogoBG}>
                    <img
                      style={{
                        width: '22px',
                        height: '22px',
                        objectFit: 'contain',
                      }}
                      src={`https://logo.ignosis.ai/${
                        acc.fipId ? acc.fipId : 'FIP-ID'
                      }.jpeg`}
                    />
                  </div>

                  {acc.accNo}
                </div>
              );
            })}
          </div>
        </div>
        <div
          style={{
            marginTop: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <Card
            style={{ width: '100%', overflow: 'hidden' }}
            actions={[
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '0px 16px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <AlignLeftOutlined
                    style={{
                      borderRadius: '50%',
                      background: '#f8f9fa',
                      width: 27,
                      height: 27,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(0,0,0,0.5)',
                    }}
                  />
                  <div
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      setIsAccountDetailsOpen(true);
                    }}
                  >
                    Bank Account Details
                  </div>
                </div>
                <RightOutlined />
              </div>,

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '0px 16px',
                }}
                onClick={() => {
                  const link = document.createElement('a');
                  link.target = '_blank';
                  link.href = getPDFURL();
                  link.download = 'bank_statement.pdf'; // File name
                  link.click();
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <DownloadOutlined
                    style={{
                      borderRadius: '50%',
                      background: '#f8f9fa',
                      width: 27,
                      height: 27,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(0,0,0,0.5)',
                    }}
                  />
                  <div style={{ marginLeft: 10 }}>
                    Download Account statement
                  </div>
                </div>
                <RightOutlined />
              </div>,
              revokedAccounts.includes(selectedAcconts.accNo.slice(-4)) ? (
                <div
                  className={styles.bankTrackingPausedContainer}
                  style={{
                    background: '#FEF1F0',
                    borderTop: '1px solid #DB5B66',
                  }}
                >
                  <Typography.Text
                    style={{
                      color: '#DB5B66',
                      fontSize: '13px',
                      marginLeft: '15px',
                    }}
                  >
                    Bank tracking is revoked!
                  </Typography.Text>
                </div>
              ) : pausedAccounts.includes(selectedAcconts.accNo.slice(-4)) ? (
                <div
                  className={styles.bankTrackingPausedContainer}
                  style={{ borderTop: '1px solid #FAB83F' }}
                >
                  <Typography.Text
                    style={{
                      color: '#FAB83F',
                      fontSize: '13px',
                      marginLeft: '15px',
                    }}
                  >
                    Bank tracking is paused!
                  </Typography.Text>
                </div>
              ) : (
                <></>
              ),
            ]}
          >
            <Meta
              avatar={
                <Avatar
                  src={`https://logo.ignosis.ai/${
                    selectedAcconts.fipId ? selectedAcconts.fipId : 'FIP-ID'
                  }.jpeg`}
                />
              }
              title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ fontWeight: 600, fontSize: 18 }}>
                    {formatToINR(selectedAcconts.balance)}{' '}
                  </div>
                  <div style={{ marginLeft: 5, fontSize: 12 }}>
                    {selectedAcconts.lastUpdateTime}
                  </div>
                </div>
              }
              description={
                <div>
                  {selectedAcconts.fipName} - {selectedAcconts.accNo}
                </div>
              }
            />
          </Card>
          <Nudges nudgeList={getNudges('bank')} />
          <Tabs
            id='tabsBankSummary'
            onChange={(e) => {
              setActiveKey(e);
            }}
            activeKey={activeKey}
            defaultActiveKey='1'
            items={items}
          />
        </div>
      </div>
    </>
  );
};

export default BankSummary;
